import { useMutation } from "@apollo/client";
import { GENERATE_SYNC_ERRORS_REPORT_MUTATION } from "../../../apis/salesforce/queries";
import { HG_FORCE_CLIENT } from "../../../utils/consts";

export interface GenerateSyncErrorsReportResponse {
  generateSyncErrorsReport: string;
}

export interface GenerateSyncErrorsReportVariables {
  integrationId: string;
}

export const useGenerateSyncErrorsReport = () => {
  const [generateSyncErrorsReportMutation, result] = useMutation<
    GenerateSyncErrorsReportResponse,
    GenerateSyncErrorsReportVariables
  >(GENERATE_SYNC_ERRORS_REPORT_MUTATION, {
    context: { clientName: HG_FORCE_CLIENT },
    errorPolicy: "all",
  });

  const generateSyncErrorsReport = async (integrationId: string) => {
    const response = await generateSyncErrorsReportMutation({
      variables: { integrationId },
    });
    return response.data?.generateSyncErrorsReport;
  };

  return {
    generateSyncErrorsReport,
    ...result,
  };
};
